import React from 'react';
import { Home, BarChart3, Box, Factory, Settings, ArrowLeft, User, Menu, X, ShieldCheck, RefreshCw } from 'lucide-react';
import './dashboard-module.css';

function Brand() {
  return <a className="dm-brand" href="#/cuadro-control" aria-label="Nuevo Alfatex · Inicio"><svg viewBox="0 0 64 64" fill="none" aria-hidden="true"><g stroke="currentColor" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round"><path d="M8 20 20 8l36 36-12 12M8 44 44 8l12 12-36 36M8 32l24 24M32 8l24 24"/><path d="m20 20 24 24m-24 0 24-24"/></g></svg><span>Nuevo<br/>Alfatex<small>GESTIÓN DE NEGOCIO</small></span></a>;
}

export function DashboardModule({ children, onRefresh, reportAction }) {
  const [menuOpen, setMenuOpen] = React.useState(false);
  const close = () => setMenuOpen(false);
  const items = [
    ['Inicio', '#/cuadro-control', Home], ['Alfawin', '#/cuadro-control/alfawin', BarChart3],
    ['Almacén y pedidos', '#/cuadro-control/almacen', Box], ['Producción', '#/cuadro-control/fabricaciones', Factory],
    ['Configuración', '#/configuracion', Settings],
  ];
  return <div className="dashboard-module">
    <aside className="dm-sidebar">
      <div className="dm-brand-row"><Brand/><button className="dm-menu-toggle" type="button" aria-label={menuOpen ? 'Cerrar menú del módulo' : 'Abrir menú del módulo'} aria-expanded={menuOpen} aria-controls="dm-navigation" onClick={() => setMenuOpen(!menuOpen)}>{menuOpen ? <X/> : <Menu/>}</button></div>
      <nav id="dm-navigation" aria-label="Navegación del módulo" className={`dm-navigation ${menuOpen ? 'is-open' : ''}`}>
        {items.map(([label, href, Icon], index) => <a key={href} href={href} onClick={close} aria-current={index === 0 ? 'page' : undefined}><Icon size={20}/>{label}</a>)}
        <a href="#/articulos" onClick={close} className="dm-return"><ArrowLeft size={20}/>Volver a Alfatex</a>
      </nav>
      <div className="dm-profile"><span><User size={21}/></span>Administrador</div>
    </aside>
    <main className="dm-main">
      <header className="dm-header"><div className="dm-company-heading"><img className="dm-company-logo" src="/branding/ennage-logo.png" alt="Ennage" width="372" height="136"/><div><p>NUEVO ALFATEX</p><h1>Cuadro de mando</h1></div></div><div className="dm-header-actions"><span className="dm-admin"><ShieldCheck size={16}/>Vista de administrador</span><button type="button" onClick={onRefresh}><RefreshCw size={15}/><span>Actualizar resumen</span></button></div></header>
      {reportAction && <div className="mb-5 flex min-w-0 flex-wrap justify-end">{reportAction}</div>}
      {children}
    </main>
  </div>;
}
